import LaunchIcon from '@mui/icons-material/Launch';
import axios from 'axios';
import Button from 'blocks/Button';
import Row from 'blocks/Row';
import Breadcrumb from 'components/Breadcrumb';
import EmptyBox from 'components/EmptyBox';
import Pager from 'components/Pager';
import Table from 'components/Table';
import MerchantModal from 'components/modals/MerchantsModal';
import Paths from 'helper/paths';
import WithSidebar from 'layouts/WithSidebar';
import BreadcrumbInterface from 'models/breadcrumb/breadcrumb.interface';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import urls from 'utils/urls';
import * as S from './products.styles';

const Products = () => {
  const { t } = useTranslation();
  const [products, setProducts] = useState<any[]>([]);
  const navigate = useNavigate();
  const breadcrumbLinks = [
    {
      title: t(`pageTitles.${Paths.Dashboard.index().name}`),
      url: Paths.Dashboard.index().route,
      active: true,
    },
    {
      title: t(`pageTitles.${Paths.Services.products().name}`),
      url: '',
      active: false,
    },
  ] as BreadcrumbInterface[];

  const merchantModal = useRef<any>();

  const [pageData, setPageData] = useState({
    count: 0,
    totalPage: 0,
    page: 0,
  });
  useEffect(() => {
    getProducts(pageData.page);
  }, [pageData.page]);

  const getProducts = async (page, query?: string) => {
    let params = `?page=${page}` + (query || '');

    const res = await axios.get(urls.product + params);

    setProducts(res.data.response.data);
    setPageData({
      totalPage: res.data.response.totalPages,
      page: res.data.response.currentPage,
      count: res.data.response.totalItems,
    });
  };
  const next = (): void => setPageData({ ...pageData, page: pageData.page + 1 });

  const prev = (): void => {
    if (pageData.page === 0) return;

    setPageData({ ...pageData, page: pageData.page - 1 });
  };

  return (
    <WithSidebar>
      <S.Products>
        <Row justify="space-between" align="center">
          <Breadcrumb links={breadcrumbLinks} title={t('pages.services.Products.title')} />
          <Button
            onClick={() => {
              navigate(Paths.Services.Booking().route);
            }}
          >
            {t('pages.services.Products.dateBtn')}
          </Button>
        </Row>

        {products.length ? (
          <>
            <S.ParentTable>
              <Table
                name="products"
                head={[
                  { text: t('pages.services.Products.sections.headers.name') },
                  { text: t('pages.services.Products.sections.headers.description') },
                  { text: '' },
                ]}
                rows={products.map((product) => [
                  { content: product.name },

                  { content: product.description },

                  {
                    content: (
                      <Row justify="space-around">
                        {/* <Button color="outlined" styleType="text-button" onClick={() => {}}>
                          {t('pages.services.Products.sections.headers.viewPrice')}
                        </Button> */}
                        <Button
                          iconStart={<LaunchIcon />}
                          styleType="outlined"
                          onClick={() => {
                            merchantModal.current.openModal(product.id);
                          }}
                        >
                          {t('pages.services.Products.sections.headers.ChooseProvider')}
                        </Button>
                      </Row>
                    ),
                  },
                ])}
              />
            </S.ParentTable>

            <Pager total={pageData.count} page={pageData.page} next={next} prev={prev} />
          </>
        ) : (
          <EmptyBox boxed title={t('pages.services.Products.sections.emptyText')} />
        )}
      </S.Products>

      <MerchantModal ref={merchantModal} />
    </WithSidebar>
  );
};

export default Products;
